import script from "./DashboardSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardSidebar.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardSidebar.vue?vue&type=style&index=0&id=a7c70a50&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7c70a50"]])

export default __exports__